
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertCountComponent } from './alert-count/alert-count.component';
import { AlertItemComponent } from './alert-item/alert-item.component';
import { AlertsComponent } from './alerts.component';
import { AlertErrorComponent } from './alert-error/alert-error.component';
import { AlertCounterPipe } from './alert-counter.pipe';
import { AlertPreviewEllipse } from './alert-preview-ellipsespipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AlertCountComponent,
    AlertItemComponent,
    AlertsComponent,
    AlertErrorComponent,
    AlertCounterPipe,
    AlertPreviewEllipse
  ],
  exports: [
    AlertCountComponent,
    AlertItemComponent,
    AlertsComponent
  ]
})
export class AlertModule { }
